export const CURRENCIES = ["RON", "EUR", "USD", "GBP"];

export function buildRevolutUrl(link, amount, currency = "RON") {
  if (!link) return null;
  let url = String(link).trim();
  if (!url) return null;
  if (!/^https?:\/\//i.test(url)) url = "https://" + url.replace(/^\/+/, "");
  const amt = Number(amount || 0).toFixed(2);
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}amount=${amt}&currency=${currency}`;
}

export function fmt(amount, currency = "RON") {
  const n = Number(amount || 0);
  return `${n.toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;
}

export function lineTotal(item) {
  return Number(item.unit_price || 0) * Number(item.quantity || 0);
}

// Mirrors backend compute_summary (unit/portion based) for live local feedback.
export function itemUnits(item) {
  const q = Number(item.quantity || 0);
  const price = Number(item.unit_price || 0);
  if (Number.isInteger(q) && q >= 1) return { numUnits: q, unitValue: price };
  return { numUnits: 1, unitValue: price * q };
}

export function computeLocal(session) {
  const items = session.items || [];
  const guests = session.guests || [];

  const subtotals = {};
  guests.forEach((g) => (subtotals[g.id] = 0));

  items.forEach((item) => {
    const { numUnits, unitValue } = itemUnits(item);
    const unitClaims = {}; // unitIdx -> [guestIds]
    for (let u = 0; u < numUnits; u++) unitClaims[u] = [];
    const guestUnits = {}; // guestId -> [unitIdx]
    guests.forEach((g) => {
      const sel = (g.selections || []).find((s) => s.item_id === item.id);
      const units = sel ? (sel.units || []).filter((u) => Number.isInteger(u) && u >= 0 && u < numUnits) : [];
      guestUnits[g.id] = units;
      units.forEach((u) => unitClaims[u].push(g.id));
    });
    guests.forEach((g) => {
      let portion = 0;
      (guestUnits[g.id] || []).forEach((u) => {
        const n = unitClaims[u].length;
        if (n > 0) portion += unitValue / n;
      });
      subtotals[g.id] += portion;
    });
  });

  const totalAssigned = Object.values(subtotals).reduce((a, b) => a + b, 0);
  const adjustments =
    (session.service_fee || 0) + (session.tip || 0) - (session.discount || 0);

  const out = {};
  guests.forEach((g) => {
    const sub = subtotals[g.id];
    const ratio = totalAssigned > 0 ? sub / totalAssigned : 0;
    out[g.id] = { subtotal: sub, adjustments: adjustments * ratio, total: sub + adjustments * ratio };
  });
  return out;
}
